import '../App.css';
import React, { useEffect  } from 'react';

const AdsComponent = (props) => {
    const { dataAdSlot, clase } = props;  



    useEffect(() => {

        try {
            (window.adsbygoogle = window.adsbygoogle || []).push({});
        }

        catch (e) {

        }

    },[]);



    return (
        <>
            <ins className={`adsbygoogle ${clase}`}
                style={{ display: "block" }}
                data-ad-client="ca-pub-5146509566368759"
                data-ad-slot={dataAdSlot}
                data-full-width-responsive="true">
                
            </ins>
        </>
    );
};

export default AdsComponent;